/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import "core-js/stable"
import "regenerator-runtime/runtime"
import Rails from 'rails-ujs'
import 'bootstrap/js/dist/dropdown'

import { } from '../components'
import * as Sentry from "@sentry/react"
import { Integrations } from "@sentry/tracing"

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://bf31d4469478404cb690a0da36f45712@o544986.ingest.sentry.io/5666352",
    integrations: [new Integrations.BrowserTracing()],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.5,
  })
}

Rails.start()
